import './index.scss'

const HeadingMain = (props) => {
	return (
            <h2 className="headingMain" {...props} style={props.color && {color: props.color}}>
                {props.text}
            </h2>
	)
}

export default HeadingMain;